import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { setSelectedVariant as setSelectedVariantAction } from '../../Actions/ProductPage.action';
import { setProductPageSelectedVariantQuery as setProductPageSelectedVariantQueryAction } from '../../Actions/ProductPage.action';
import { translate } from '../../Services/translation';
import StockStatusTag from '../StockStatusTag';
import QuantityBuyButton from './QuantityBuyButton';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import DynamicComponent from '../DynamicComponent';

const VariantPickerContainer = ({
  productVariants,
  hideBuyButton,
  hideQuantityField,
  onVariantSelected,
  isBuyableChannel,
  storesUrl,
  selectedVariantId,
}) => {
  const dispatch = useDispatch();
  const articleIndex = productVariants.findIndex(item => item.articleNumber === selectedVariantId);
  const [selectedVariant, setSelectedVariant] = useState(
      productVariants.length > 1 ? productVariants[articleIndex] : productVariants[0]
  );
  
  const formatPriceHtml = (variant) => {
    if (!variant.price || !variant.price.hasPrice) return '';
    
    let priceHtml = '';
    
    if (variant.price.hasCampaignPrice) {
      priceHtml = `
        <span class="product-page__price--campaign-price">${variant.price.formattedCampaignPrice}</span>
        <span class="[ product-page__price--original ] [ color-grey-900 text-small ]">(${variant.price.formattedPrice})</span>
      `;
    } else if (variant.price.hasTierPrices && variant.price.tierPrices.length > 0) {
      priceHtml = `<span>${variant.price.tierPrices[0].formattedPrice}</span>`;
    } else {
      priceHtml = `<span>${variant.price.formattedPrice}</span>`;
    }
    
    if (variant.hasPriceHistory) {
      priceHtml += `
        <div id="price-history" 
             data-description="${variant.priceHistoryDescription || ''}"
             data-numberOfDays="${variant.priceHistoryNumberOfDays || ''}"
             data-previouslyLowestPrice="${variant.priceHistoryPreviouslyLowestPrice || ''}"
             data-title="${variant.priceHistoryTitle || ''}"
             data-id="${variant.articleNumber}">
        </div>
      `;
    }
    
    return priceHtml;
  };

  const showCorrectVariantPrice = (variant) => {
    const priceContainer = document.getElementById('product-page-active-price');
    if (!priceContainer) return;
    
    priceContainer.setAttribute('data-variant-id', variant.articleNumber);
    const priceHtml = formatPriceHtml(variant);
    priceContainer.innerHTML = priceHtml || '';
    
    const priceHistoryElem = priceContainer.querySelector('#price-history');
    if (priceHistoryElem) {
      const priceHistory = {
        description: priceHistoryElem.dataset.description,
        numberOfDays: priceHistoryElem.dataset.numberofdays,
        previouslyLowestPrice: priceHistoryElem.dataset.previouslylowestprice,
        title: priceHistoryElem.dataset.title,
        id: priceHistoryElem.dataset.id,
      };

      const PriceHistoryContainerComponent = DynamicComponent({
        loader: () => import('../../Containers/PriceHistoryContainer'),
      });

      ReactDOM.render(
        <Provider store={global.LitiumReduxStore}>
          <PriceHistoryContainerComponent priceHistory={priceHistory} />
        </Provider>,
        priceHistoryElem
      );
    }
  };
  
  const onVariantClick = (variant) => {
    setSelectedVariant(variant);
    dispatch(setSelectedVariantAction(variant));
    setProductPageSelectedVariantQueryAction(variant);
    if (onVariantSelected) {
      onVariantSelected(variant);
    }
    showCorrectVariantPrice(variant);
  };
  
  const fixedSizeVariants = productVariants.filter(
    (v) => !v.size.startsWith('Ø')
  );
  const roundSizeVariants = productVariants.filter((v) =>
    v.size.startsWith('Ø')
  );
  
  return (
    <div className="variant-list">
      {fixedSizeVariants.length > 0 && (
        <div className="variant-list__heading [ text-medium lh-2 bold color-grey-900 ]">
          {translate('product-page.fixed-sizes')}
        </div>
      )}
      <div className="variant-list__list">
        {fixedSizeVariants.length > 0 &&
          fixedSizeVariants.map((variant, index) => (
            <div
              className="[ variant-list__variant ] [ text-medium ]"
              data-active={
                variant.articleNumber === selectedVariant?.articleNumber
                  ? 'active'
                  : 'inactive'
              }
              key={variant.articleNumber}
              onClick={() => {
                onVariantClick(variant);
              }}
            >
              {variant.size}
            </div>
          ))}
      </div>
      {roundSizeVariants.length > 0 && (
        <div className="variant-list__heading variant-list__heading--round [ text-medium lh-2 bold color-grey-900 ]">
          {translate('product-page.round-sizes')}
        </div>
      )}
      <div className="variant-list__list variant-list__list--round">
        {roundSizeVariants.length > 0 &&
          roundSizeVariants.map((variant) => (
            <div
              className="[ variant-list__variant ] [ text-medium ]"
              data-active={
                variant.articleNumber === selectedVariant?.articleNumber
                  ? 'active'
                  : 'inactive'
              }
              key={variant.articleNumber}
              onClick={() => {
                onVariantClick(variant);
              }}
            >
              {variant.size}
            </div>
          ))}
      </div>
      {!hideBuyButton && isBuyableChannel && (
        <div className="[ stock-status stock-status--variants ] [ text-small lh-2 color-grey-900 show-for-medium ]">
          {selectedVariant && (
            <StockStatusTag
              description={selectedVariant.stockStatusDescription}
              stockStatusType={selectedVariant.stockStatusType}
            />
          )}
        </div>
      )}
      {!hideQuantityField && isBuyableChannel && (
        <QuantityBuyButton
          selectedVariantArtNumber={selectedVariant?.articleNumber}
        />
      )}
      {!isBuyableChannel && storesUrl && (
        <a
          style={{ marginTop: '1rem', marginBottom: '1rem', maxWidth: '300px' }}
          className="buy-button"
          href={storesUrl}
        >
          {translate('product-page.find-your-store')}
        </a>
      )}
    </div>
  );
};

export default VariantPickerContainer;
